import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import styles from './styles/index.module.scss';

const Overlay = ({ children }) => {
  const element = document.createElement('div');

  element.className = styles.overlay;

  useEffect(() => {
    document.body.appendChild(element);

    return () => {
      document.body.removeChild(element);
    };
  }, []);

  return createPortal(children, element);
};

export default Overlay;
